// extracted by mini-css-extract-plugin
module.exports = {"container":"container_container__1MY9F"};